<template>
  <div class="tokenized-input-root">
    <div class="container">
      <label v-if="labelText">
        {{ labelText }}
        <a :href="helpLink" v-if="helpLink"><i class="circle help icon"></i></a>
      </label>

      <div
        class="tokenized-input"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
      >
        <span v-for="token in tokens" :key="token.id" @click="showMenu($event, token)">
          <slot :name="`${token.template}`" :model="token" />
        </span>

        <span v-if="canAdd" @click="add">
          <slot name="add">
            <div class="ui tiny green icon button"><i class="ui plus icon"></i></div>
          </slot>
        </span>
      </div>

      <!-- The menu for a token -->
      <div
        class="token-menu inline dropdown"
        v-if="menu"
        style="display: block !important; z-index: 100;"
        :style="{ left: showMenuAt.left, right: showMenuAt.right }"
        v-on-clickaway="hideMenu"
      >
        <slot :name="`${menu.model.template}.menu`" :model="menu.model" :token="menu.token" />
      </div>
    </div>
  </div>
</template>
<style lang="scss">
// Note: Not 'scoped' because we manually insert elements with classes
@charset "utf-8";

.tokenized-input-root {
  display: contents; // Browser pretends contents were directly in the parent container, but this still gets to be the root element of the vue component

  .container {
    width: 100%;
  }

  $editor-line-height: 2em;
  $editor-padding: 0.5em 0.5em;

  .tokenized-input {
    background-color: white;
    line-height: $editor-line-height;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 0.28571429rem;
    color: black;
    outline: none;
    transition: border-color 0.1s ease;
    padding: $editor-padding;

    // Hack: If used elsewhere, these corners should probably be round
    //border-top-right-radius: 0;
    //border-bottom-right-radius: 0;

    &:focus {
      border-color: #85b7d9;
      box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.35) inset;
    }
  }

  .token-menu {
    position: absolute !important; // Overrule fomantic so we can position dynamically
  }

  label {
    display: inline-block;
    font-weight: bold;
    margin-bottom: 3px;
    font-size: 0.9em;
  }
}
</style>
<script>
// @flow
import _ from 'lodash'
import ClickOutsideDirective from 'ui'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'tokenized-input',
  components: {},
  mixins: [clickaway],
  props: {
    tokens: { type: Array, default: () => [] },
    menus: { type: Array, default: () => [] },
    canAdd: { type: Boolean, default: () => true },
    labelText: { type: String, default: () => '' },
    helpLink: { type: String, default: () => '' }
  },

  data() {
    return {
      selectingForIndex: -1,
      showMenuForToken: null,
      showMenuAt: { top: '0px', left: '0px' }
    }
  },

  computed: {
    menu() {
      if (this.showMenuForToken) {
        return {
          token: this.showMenuForToken,
          model: _.find(this.menus, m => m.template === this.showMenuForToken.template)
        }
      }
      return null
    }
  },

  methods: {
    add() {
      this.$emit('add')
      this.$emit('change', this.tokens)
    },
    showMenu(evt, token) {
      this.showMenuForToken = token

      this.showMenuAt = {
        left: evt.target.offsetLeft + 'px',
        top: evt.target.offsetTop + 50 + 'px'
      }

      this.$emit('menuShown', { menu: this.menu, token: token })
    },

    hideMenu() {
      this.showMenuForToken = null
      this.$emit('change', this.tokens)
      this.$emit('menuHidden')
    }
  }
}
</script>
